import axios from 'config/api';
import {
  ADD_RECORD_ERROR,
  ADD_RECORD_SUCCESS,
  UPDATE_RECORD_ERROR,
  UPDATE_RECORD_SUCCESS,
  DOWNLOAD_FILE_ERROR,
} from 'config/constants';

function addRecord(record) {
  return axios
    .post(`/user/templates-records/`, record)
    .then(response => {
      const { data, status } = response;
      if (status === 200) {
        return {
          type: ADD_RECORD_SUCCESS,
          record: data,
        };
      }
      throw response;
    })
    .catch(error => {
      const {
        response: { data, status },
      } = error;
      if (data && (status === 400 || status === 403 || status === 422)) {
        return {
          type: ADD_RECORD_ERROR,
          message: data.error,
        };
      }
      throw error;
    });
}

function updateRecord(record) {
  return axios
    .put(`/user/templates-records/${record.templateId}`, record)
    .then(response => {
      const { data, status } = response;
      if (status === 200) {
        return {
          type: UPDATE_RECORD_SUCCESS,
          record: data,
        };
      }
      throw response;
    })
    .catch(error => {
      const {
        response: { data, status },
      } = error;
      if (data && (status === 400 || status === 403 || status === 422)) {
        return {
          type: UPDATE_RECORD_ERROR,
          message: data.error,
        };
      }
      throw error;
    });
}

function templateDownload(template) {
  axios
    .post(`/admin/templates/rtf/`, template)
    .then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const fileName = `${template.title}.rtf`;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    })
    .catch(error => {
      const {
        response: { data, status },
      } = error;
      if (data && (status === 400 || status === 403 || status === 422)) {
        return {
          type: DOWNLOAD_FILE_ERROR,
          message: data.error,
        };
      }
      throw error;
    });
}

export default {
  addRecord,
  updateRecord,
  templateDownload,
};
